import { Broadcast } from "./Broadcast"

/**
 * Extended broadcast that maintains memory of all emitted messages.
 * New subscribers receive all past messages before getting new ones.
 */

export function ReplayBroadcast<T>(): ReturnType<typeof Broadcast<T>> {
  const messages: T[] = []
  const { stop, push, subscribe } = Broadcast<T>(messages)

  // Return broadcast instance with overridden push
  return {
    subscribe,
    stop,
    push: item => {
      messages.push(item)
      push(item)
    },
  }
}
